import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setVisionEquipments = (state, { visionEquipments }) => {
  if (!visionEquipments) return state;
  return state.merge({ visionEquipments });
};
const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};
export const callbacks = [
  {
    actionType: ActionTypes.SET_VISION_EQUIPMENTS,
    actionFunction: setVisionEquipments,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
];
